/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Groupindex_Title1Inputs */

const en_seo_groupindex_title1 = /** @type {(inputs: Seo_Groupindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const zh_seo_groupindex_title1 = /** @type {(inputs: Seo_Groupindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部分组`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Seo_Groupindex_Title1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const seo_groupindex_title1 = /** @type {((inputs?: Seo_Groupindex_Title1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Groupindex_Title1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seo_groupindex_title1(inputs)
	return zh_seo_groupindex_title1(inputs)
});
export { seo_groupindex_title1 as "seo.groupIndex.title" }